import React, { useState, useEffect } from "react";
import { selfserviceUser } from "../../redux/actions";
import { useSelector } from "react-redux";

const SelfserviceUsers = () => {
  const [user, setUser] = useState([]);
  const [error, setError] = useState([]);
  const user_data = useSelector((state) => state?.user_data?.user_data);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    if (user_data) {
      const active = user_data?.is_active;
      const admin = user_data?.is_admin;
      const power = user_data?.is_poweruser;

      if (active && admin) {
        setSelectedOption("admin");
      } else if (active && power) {
        setSelectedOption("poweruser");
      } else {
        setSelectedOption("local");
      }
    }
  }, [user_data]); // Runs only when `user_action` changes

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceUser();
        setUser(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOrders();
  }, []);

  const all_user = user?.page?.data?.users?.data || [];
  const action = "add";
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  const totalPages = Math.ceil(all_user.length / usersPerPage);

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = all_user.slice(indexOfFirstUser, indexOfLastUser);

  // Function to generate page numbers
  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h2 className="mb-0 text-blue">USERS</h2>
          </div>
        </div>
      </div>

      <div className="container container-lg ">
        <div className="row gy-4">
          {/* grid for orders */}
          <div className="col-sm-12 ">
            <div>
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                {/* Table */}
                {selectedOption === "poweruser" ||
                selectedOption === "admin" ? (
                  <div>
                    {/* Table */}
                    <table className="table rounded-8 overflow-hidden">
                      <thead>
                        <tr className="border-bottom border-neutral-80">
                          <th className="h6 mb-0 text-lg fw-bold px-80 py-6">
                            Name
                          </th>
                          <th className="h6 mb-0 text-lg fw-bold px-80 py-6">
                            Role
                          </th>
                          <th className="h6 mb-0 text-lg fw-bold px-80 py-6">
                            Status
                          </th>
                          <th className="h6 mb-0 text-lg fw-bold px-80 py-6"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.map((data, index) => (
                          <tr
                            className="border-bottom border-neutral-80 py-6"
                            key={index}
                          >
                            <td className="px-80 py-12">{data?.name}</td>
                            <td className="px-80 py-12">
                              {data?.is_admin
                                ? "Admin"
                                : data?.is_poweruser
                                ? "Power User"
                                : "Local"}
                            </td>
                            <td
                              className="px-80 py-12"
                              style={{ textAlign: "left" }}
                            >
                              {data?.is_active === false && (
                                <button className="btn text-gray-500 bg-light-grey">
                                  Blocked
                                </button>
                              )}
                              {data?.is_active === true &&
                                data?.email_confirmed === true && (
                                  <button className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap">
                                    Active
                                  </button>
                                )}
                              {data?.is_active === true &&
                                data?.email_confirmed === false && (
                                  <button className="btn pending_btn">
                                    Pending
                                  </button>
                                )}
                            </td>
                            <td className="px-80 py-6">
                              <a
                                href={`/self-service/users/action/edit/${data.id}`}
                              >
                                <i className="ph ph-caret-right animated-caret"></i>
                              </a>
                            </td>
                          </tr>
                        ))}

                        <tr className="border-bottom border-neutral-80 py-6">
                          <td className="px-80 py-12">
                            <a
                              href={`/self-service/users/action/edit/${action}`}
                            >
                              <button className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap">
                                Add new user
                              </button>
                            </a>
                          </td>
                          <td className="px-80 py-12"></td>
                          <td className="px-80 py-12"></td>
                          <td className="px-80 py-6"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <h2>You are not authorised to view the data!</h2>
                )}

                <br></br>
                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center mt-4 w-100">
                    <div className="text-center">
                      <button
                        style={{
                          backgroundColor: currentPage > 1 ? "blue" : "#9db9e3",
                          color: "white",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.25rem",
                          border: "none",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "blue")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#9db9e3")
                        }
                        className="mx-1"
                        onClick={() =>
                          currentPage > 1 && setCurrentPage(currentPage - 1)
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>

                      {/* Page Number Buttons */}
                      {getPageNumbers().map((page, idx) => {
                        const isActive = page === currentPage;
                        return (
                          <button
                            key={idx}
                            style={{
                              backgroundColor: isActive ? "blue" : "#9db9e3",
                              color: "white",
                              padding: "0.5rem 1rem",
                              borderRadius: "0.25rem",
                              border: "none",
                              transition: "background-color 0.3s",
                            }}
                            onMouseEnter={
                              !isActive
                                ? (e) =>
                                    (e.target.style.backgroundColor = "blue")
                                : undefined
                            }
                            onMouseLeave={
                              !isActive
                                ? (e) =>
                                    (e.target.style.backgroundColor = "#9db9e3")
                                : undefined
                            }
                            className="mx-1"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {/* Next Button */}
                      <button
                        style={{
                          backgroundColor:
                            currentPage < totalPages ? "blue" : "#9db9e3",
                          color: "white",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.25rem",
                          border: "none",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "blue")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#9db9e3")
                        }
                        className="mx-1"
                        onClick={() =>
                          currentPage < totalPages &&
                          setCurrentPage(currentPage + 1)
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* grid for savings */}
        </div>
      </div>
    </section>
  );
};

export default SelfserviceUsers;
